import _createForOfIteratorHelper from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
/**
 * lodash compatible methods
 */

import deepmerge from 'deepmerge';

/**
 * get value at `keys` from `object`
 * @example
 * get({a: {b: {c: 2}}}, ['a', 'b', 'c']) //> 2
 */
export var get = function get(obj) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var def = arguments.length > 2 ? arguments[2] : undefined;
  var o = obj;
  if (typeof keys === 'string') keys = keys.split('.');
  var _iterator = _createForOfIteratorHelper(keys),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (o && o[key]) {
        o = o[key];
      } else {
        return def;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return o;
};

/**
 * set `value` at `keys` from `object`
 * @example
 * set({a: {b: {c: 2}}}, ['a', 'b', 'c'], 3)
 */
export var set = function set(obj) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var value = arguments.length > 2 ? arguments[2] : undefined;
  var key;
  var ref;
  var o = obj;
  var _iterator2 = _createForOfIteratorHelper(keys),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      key = _step2.value;
      ref = o;
      if (toString.call(o[key]) !== '[object Object]') o[key] = {};
      o = o[key];
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  ref[key] = value;
  return obj;
};

/**
 * omit `object` properties `props`
 */
export var omit = function omit(object) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Object.keys(object).filter(function (p) {
    return !~props.indexOf(p);
  }).reduce(function (o, p) {
    p in object && (o[p] = object[p]);
    return o;
  }, {});
};
export var merge = function merge() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return deepmerge.all(args);
};
export var toNumber = function toNumber(num, def) {
  var _num = Number(num);
  return isNaN(_num) ? def : _num;
};
export default {
  get: get,
  set: set,
  omit: omit,
  merge: merge
};